import React from 'react';
import Header from './Header';
import ViewportTracker from './ViewportTracker';
import VicktoriaDefault from './assets/Vicktoria_Default.png';
import VicktoriaCheeky from './assets/Vicktoria_Cheeky_Side_Profile.png';
import VicktoriaSmile from './assets/Vicktoria_Slight_Smile.png';
import { PAGE_MAX_WIDTH, PAGE_CONTAINER_MARK } from './layout';
import { TAM_INTRO_PARAGRAPH } from './trueAgileMindsetCopy';
// Plan purchasing paused during the Vicktoria rework (2026-06-12) — see SubscriptionSection.
// import { useNavigate } from 'react-router-dom';
// Colors configuration
const colors = {
  bg: '#D1DEE6',
  card: '#81B2CA',
  cardSecondary: '#81B2CA',
  button: '#4A8EB3',
  textDark: '#2B1E19',
  white: '#FFFFFF',
};

// Hero Section Component
const HeroSection = () => {
  return (
    <section style={{ backgroundColor: colors.bg, width: '100%', display: 'flex', justifyContent: 'center' }}>
      <style>
        {`
          @media (max-width: 1100px) {
            .hero-main-box {
              flex-direction: column !important;
              padding: 10px 20px !important;
              text-align: center !important;
            }

            .image-text-wrapper {
              flex: none !important;
              width: 100% !important;
            }

            .description-wrapper {
              flex: none !important;
              width: 100% !important;
              margin-top: 0px;
            }

            /* The "Slow Scale" Logic */
            .img-container-mobile {
              height: auto !important;
              min-height: 200px;
            }

            .v-img-side {
              width: 28vw !important; /* Scale based on viewport width */
              height: 28vw !important;
              max-width: 180px !important;
              max-height: 180px !important;
            }

            .v-img-middle {
              width: 28vw !important;
              height: 31vw !important; /* Keep middle slightly taller */
              max-width: 180px !important;
              max-height: 200px !important;
              margin-left: -3vw !important; /* Overlap shrinks proportionally */
              margin-right: -3vw !important;
            }

            .hero-headline {
              font-size: 26px !important;
              margin-top: 15px !important;
            }
          }
          @media (max-width: 500px) {
          .middle-image {
              margin-right: -20px !important
            }
          }
            /* Hide when the viewport is 500px or smaller */
          @media (max-width: 500px) {
            .hero-text-container {
              display: none !important;
            }
            .subscription-header-block {
              justify-content: center !important;
              align-self: center
            }
            .perks-header {
              font-size: 18px !important;
              padding: 12px 16px !important;
              margin-bottom: 10px !important;
              font-weight: 600 !important;
              
            }
            .payment-button {
              display: none !important;
            }
            .payment-button-hidden {
            display: block !important
            }
            .vicktoria-wrapper {
              display: none !important;
            }
            /* 1. Center the parent container */
            .perks-container {
              text-align: center !important;
            }

            /* 2. Update the header to block so it fills the width and centers text */
            .perks-header {
              font-size: 18px !important;
              padding: 12px 16px !important;
              margin-bottom: 10px !important;
              font-weight: 600 !important;
              display: block !important;       /* Overrides inline-block */
              text-align: center !important;   /* Centers the text */
            }

            /* 3. Ensure the list items center properly */
            .perks-list {
              text-align: center !important;
            }
            .perks-content-wrapper{
              flex-direction: column !important;
              gap: 20px !important;
            }
            .top-border {
              border-top: 2px solid ${colors.white} !important;
            }
            .bottom-border {
              border-bottom: 2px solid ${colors.white} !important;
            }
          }

        `}
      </style>
      <div data-layout={PAGE_CONTAINER_MARK} style={{
        width: '100%',
        maxWidth: PAGE_MAX_WIDTH,
        margin: '0 auto',
        padding: '0 5%',
        boxSizing: 'border-box',
      }}>
        <div className="hero-main-box" style={{
          backgroundColor: '#B3CFDB',
          borderRadius: '40px',
          padding: '40px',
          boxSizing: 'border-box',
          display: 'flex',
          gap: '0px',
          alignItems: 'center'
        }}>
          {/* Left side: Image and headline */}
          <div className="image-text-wrapper" style={{ flex: 1.7 }}>
            <div className="img-container-mobile" style={{
              backgroundColor: '',
              borderRadius: '20px',
              height: '250px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'white',
              position: 'relative',
              gap: '0px',
            }}>
              {/* Left image */}
              <img 
                src={VicktoriaDefault} 
                className="v-img-side"
                alt="Vicktoria" 
                style={{ width: '180px', height: '180px', objectFit: 'cover', position: 'relative', zIndex: 1 }}
              />
              
              {/* Middle image */}
              <img 
                src={VicktoriaSmile} 
                className="v-img-side middle-image"
                alt="Vicktoria" 
                style={{ width: '180px', height: '180px', objectFit: 'cover', position: 'relative', zIndex: 2, marginLeft: '-20px', marginRight: '-45px' }}
              />
              
              {/* Right image */}
              <img 
                src={VicktoriaCheeky} 
                className="v-img-side"
                alt="Vicktoria" 
                style={{ width: '180px', height: '180px', objectFit: 'cover', position: 'relative', zIndex: 1 }}
              />
            </div>
            <h2 className="hero-headline" style={{
              fontSize: '32px',
              color: '#000000',
              marginTop: '20px',
              fontWeight: '400',
              fontFamily: 'Judson, sans-serif',
              marginBottom: '0px',
              maxWidth: '475px',
              margin: '0 auto',
              textAlign: 'center'
            }}>
              Vicktoria's expressive nature makes her more engaging than other Large Language Models.
            </h2>
          </div>
          
          {/* Right side: Description */}
          <div className="description-wrapper" style={{
            flex: 1,
            fontSize: '18px',
            lineHeight: '1.6',
            color: colors.textDark,
            fontFamily: 'Inter, sans-serif'
          }}>
            <p>{TAM_INTRO_PARAGRAPH}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

// Plan definitions — single source of truth for the pricing page
// Layout:
//   Row 1: Standard + Annual
//   Row 2: Academic + Nonprofit
//   Row 3: Active Military + Government Employee
//   Row 4: Military Veteran (single card, centered at half-width on desktop)
//          — currently HIDDEN, see the `hidden` flag on that plan below.
//
// A plan with `hidden: true` is kept in this list but not rendered; a row
// left with no visible plans is dropped entirely, so the pricing panel
// shrinks to fit the remaining cards. Restore a plan by deleting its flag.
export const PLAN_ROWS = [
  [
    {
      code: 'N',
      name: 'Standard',
      price: '$30',
      period: '/month',
      perks: [
        'Access to comprehensive logic',
        'Emotional support companion',
        'Leadership and wellness coach',
        'Cancel anytime',
      ],
    },
    {
      code: 'A',
      name: 'Annual',
      price: '$25',
      period: '/month',
      badge: 'Best Value',
      perks: [
        'Everything in Standard',
        'Save $60 vs. Standard Plan',
        'Billed annually at $300',
        'Renewal reminder before billing',
        'Cancel anytime',
      ],
    },
  ],
  [
    {
      code: 'E',
      name: 'Academic',
      price: '$20',
      period: '/month',
      perks: [
        'Everything in Standard',
        'Reduced monthly rate',
        '.edu email required',
        'Cancel anytime',
      ],
    },
    {
      code: 'O',
      name: 'Nonprofit',
      price: '$15',
      period: '/month',
      perks: [
        'Everything in Standard',
        'Half of the monthly price',
        '.org email required',
        'Cancel anytime',
      ],
    },
  ],
  [
    {
      code: 'M',
      name: 'Active Military',
      price: '$15',
      period: '/month',
      perks: [
        'Everything in Standard',
        'Half of the monthly price',
        '.mil email required',
        'Cancel anytime',
      ],
    },
    {
      code: 'G',
      name: 'Government Employee',
      price: '$15',
      period: '/month',
      perks: [
        'Everything in Standard',
        'Half of the monthly price',
        '.gov email required',
        'Cancel anytime',
      ],
    },
  ],
  [
    {
      code: 'M',
      name: 'Military Veteran',
      price: '$15',
      period: '/month',
      comingSoon: true,
      // FOLLOW-UP (2026-09-26): hidden while veteran verification is on hold
      // pending VA Lighthouse API approval. Delete this flag to show the card
      // again (it will still render as "Coming Soon" until comingSoon is removed).
      hidden: true,
      perks: [
        'Everything in Standard',
        'Half of the monthly price',
        'Third party verification required',
        'Cancel anytime',
      ],
    },
  ],
];

// Filters out `hidden` plans and drops rows that end up empty.
export const visiblePlanRows = (rows) =>
  rows
    .map((row) => row.filter((plan) => !plan.hidden))
    .filter((row) => row.length > 0);

// Subscription Card Component — two-row grid
const SubscriptionSection = ({ loggedInUser }) => {
  // --- Plan purchasing paused during the Vicktoria rework (2026-06-12). ---
  // Get Started routing is on hold while we retarget; every plan now renders a
  // disabled "Coming Soon" button (see the plan card below). To restore, un-
  // comment navigate + trialActive + handleGetStarted, re-enable the
  // `useNavigate` import at the top of this file, and swap the button back.
  //
  // const navigate = useNavigate();
  //
  // const trialActive = loggedInUser && (() => {
  //   const trialEnd = new Date(loggedInUser.accountCreationDate);
  //   trialEnd.setDate(trialEnd.getDate() + 14);
  //   return new Date() < trialEnd;
  // })();
  //
  // const handleGetStarted = (planCode) => {
  //   localStorage.setItem('selectedPlan', planCode);
  //
  //   if (!loggedInUser) {
  //     // Store where to land after auth, then send to signup with plan in context
  //     localStorage.setItem('postLoginRedirect', '/special');
  //     navigate('/signup');
  //     return;
  //   }
  //
  //   if (loggedInUser.isSpecialPermission || trialActive) {
  //     navigate('/special');
  //   } else {
  //     navigate('/payment');
  //   }
  // };

  // Show "FREE for 14 days" badge for new / unauthenticated visitors
  const showTrialBadge = !loggedInUser || loggedInUser.freeTrialAvailable;

  return (
    <section style={{ backgroundColor: colors.bg, width: '100%', display: 'flex', justifyContent: 'center' }}>
      <style>{`
        .plans-grid {
          display: flex;
          flex-direction: column;
          gap: 20px;
        }
        .plans-row {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
        }
        /* Single-card row: center the card horizontally and constrain it to
           the same width a card would have in a two-column row, so it lines
           up visually with the cards above it. */
        .plans-row-single {
          justify-content: center;
        }
        .plans-row-single .plan-card {
          flex: 0 0 calc(50% - 10px);
          max-width: calc(50% - 10px);
        }
        .plan-card {
          flex: 1;
          min-width: 220px;
          background-color: ${colors.card};
          border-radius: 24px;
          padding: 28px 24px;
          display: flex;
          flex-direction: column;
          gap: 14px;
          font-family: Inter, sans-serif;
          position: relative;
          box-sizing: border-box;
        }
        .plan-card-highlight {
          outline: 3px solid ${colors.button};
          outline-offset: -3px;
        }
        .plan-badge {
          position: absolute;
          top: -12px;
          left: 50%;
          transform: translateX(-50%);
          background-color: #F5C518;
          color: ${colors.textDark};
          font-size: 11px;
          font-weight: 700;
          padding: 3px 12px;
          border-radius: 20px;
          white-space: nowrap;
          font-family: Inter, sans-serif;
        }
        .plan-get-started {
          background-color: ${colors.button};
          color: ${colors.white};
          border: none;
          padding: 12px 0;
          border-radius: 12px;
          font-size: 17px;
          cursor: pointer;
          width: 100%;
          font-family: Judson, serif;
          font-weight: 600;
          margin-top: auto;
        }
        .plan-get-started:hover { opacity: 0.9; }
        .plan-get-started[disabled] { opacity: 0.5; cursor: not-allowed; }
        .plan-card-coming-soon { overflow: hidden; }
        .plan-card-coming-soon .plan-card-content { opacity: 0.55; }
        .plan-card-coming-soon::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: linear-gradient(
            135deg,
            transparent calc(50% - 1.5px),
            rgba(43, 30, 25, 0.55) calc(50% - 1.5px),
            rgba(43, 30, 25, 0.55) calc(50% + 1.5px),
            transparent calc(50% + 1.5px)
          );
          pointer-events: none;
          border-radius: 24px;
          z-index: 2;
        }
        .plan-coming-soon-banner {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(-10deg);
          background-color: #F5C518;
          color: ${colors.textDark};
          padding: 6px 14px;
          border-radius: 8px;
          font-family: Inter, sans-serif;
          font-weight: 800;
          font-size: 13px;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          white-space: nowrap;
          max-width: 88%;
          text-align: center;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18);
          z-index: 3;
          box-sizing: border-box;
        }
        @media (max-width: 680px) {
          .plans-row { flex-direction: column; }
          .plan-card { min-width: unset; }
          /* On mobile, let the single-card row span the full width like
             every other card — half-width centering only makes sense on
             desktop where there's a paired card visually above it. */
          .plans-row-single .plan-card {
            flex: 1 1 100%;
            max-width: none;
          }
        }
      `}</style>

      <div data-layout={PAGE_CONTAINER_MARK} style={{ width: '100%', maxWidth: PAGE_MAX_WIDTH, margin: '0 auto', padding: '0 5%', boxSizing: 'border-box' }}>

        <div style={{ backgroundColor: '#B3CFDB', borderRadius: '40px', padding: '40px', boxSizing: 'border-box' }}>

          {/* Section header */}
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <h3 style={{ margin: 0, color: colors.textDark, fontSize: '24px', fontFamily: 'Inter, sans-serif' }}>
              Vicktoria AI™ Subscription Options 
            </h3>
            {showTrialBadge && (
              <p style={{ margin: '6px 0 0', color: colors.textDark, fontSize: '15px', fontWeight: '500' }}>
                All plans include a <strong>14-day free trial</strong> — no credit card required at signup
              </p>
            )}
          </div>

          {/* Plan cards — rows of two, plus a centered single-card row for
              the Military Veteran (coming soon) entry when it isn't hidden. */}
          <div className="plans-grid">
            {visiblePlanRows(PLAN_ROWS).map((row, rowIdx) => (
              <div
                key={rowIdx}
                className={`plans-row${row.length === 1 ? ' plans-row-single' : ''}`}
              >
                {row.map((plan) => (
                  <div
                    key={plan.name}
                    className={`plan-card${plan.badge ? ' plan-card-highlight' : ''}${plan.comingSoon ? ' plan-card-coming-soon' : ''}`}
                  >
                    {plan.badge && <span className="plan-badge">{plan.badge}</span>}

                    <div className="plan-card-content" style={{ display: 'flex', flexDirection: 'column', gap: '14px', flex: 1 }}>
                      {/* Plan name */}
                      <h4 style={{ margin: 0, fontSize: '18px', color: colors.white, fontFamily: 'Judson, serif' }}>
                        {plan.name}
                      </h4>

                      {/* Price */}
                      <div>
                        {showTrialBadge ? (
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
                            <span style={{ fontSize: '22px', textDecoration: 'line-through', color: 'rgba(255,255,255,0.55)' }}>
                              {plan.price}{plan.period}
                            </span>
                            <span style={{ fontSize: '18px', color: colors.bg, fontWeight: '700' }}>FREE 14 days</span>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'baseline', gap: '4px' }}>
                            <span style={{ fontSize: '28px', fontWeight: '700', color: colors.white }}>{plan.price}</span>
                            <span style={{ fontSize: '14px', color: 'rgba(255,255,255,0.75)' }}>{plan.period}</span>
                          </div>
                        )}
                        {plan.subtext && (
                          <p style={{ margin: '4px 0 0', fontSize: '12px', color: 'rgba(255,255,255,0.7)', fontStyle: 'italic' }}>
                            {plan.subtext}
                          </p>
                        )}
                      </div>

                      {/* Perks */}
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, lineHeight: '1.8', color: colors.textDark, fontWeight: '500', fontSize: '12px', whiteSpace: 'nowrap' }}>
                        {plan.perks.map((perk) => (
                          <li key={perk}>— {perk}</li>
                        ))}
                      </ul>

                      {/* Get Started purchasing paused during the Vicktoria rework
                          (2026-06-12) — every plan button is disabled. To restore:
                      <button
                        className="plan-get-started"
                        onClick={() => !plan.comingSoon && handleGetStarted(plan.code)}
                        disabled={plan.comingSoon}
                        aria-disabled={plan.comingSoon}
                      >
                        {plan.comingSoon ? 'Unavailable' : 'Get Started'}
                      </button>
                      */}
                      <button
                        className="plan-get-started"
                        disabled
                        aria-disabled="true"
                      >
                        Coming Soon
                      </button>
                    </div>

                    {plan.comingSoon && (
                      <span className="plan-coming-soon-banner" aria-label="Coming soon">
                        Coming Soon
                      </span>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>

        </div>

      </div>
    </section>
  );
};

// Demo Section Component
const DemoSection = () => {
  return (
    <div style={{
      width: '100%',
      backgroundColor: colors.cardSecondary,
      borderRadius: '40px',
      padding: '40px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      height: '100%'
    }}>
      <h3 style={{
        fontSize: '32px',
        textAlign: 'center',
        margin: '0',
        color: colors.textDark,
        fontFamily: 'Judson, serif'
      }}>
        Vicktoria Demo
      </h3>
      <div style={{
        backgroundColor: '#1E1B18',
        borderRadius: '20px',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        overflow: 'hidden'
      }}>
        [Video Placeholder / Tutorial UI]
      </div>
      <p style={{
        textAlign: 'center',
        fontSize: '14px',
        fontStyle: 'italic',
        fontFamily: 'Inter, sans-serif',
        margin: 0
      }}>
        See how Vicktoria interacts in real-time
      </p>
    </div>
  );
};

// Two Column Layout Section Component
// 2. Updated TwoColumnSection to stack Subscription and Demo
const TwoColumnSection = ({  loggedInUser }) => {
  return (
    <section style={{ backgroundColor: colors.bg, width: '100%', display: 'flex', justifyContent: 'center' }}>
      <style>
        {`
          
            .columns-stack {
              flex-direction: column !important;
              align-items: center;
            }
            .column-item {
              width: 100% !important;
              flex: none !important;
            }
          }
        `}
      </style>
      <div data-layout={PAGE_CONTAINER_MARK} style={{ width: '100%', maxWidth: PAGE_MAX_WIDTH, margin: '0 auto', padding: '0 5%', boxSizing: 'border-box' }}>
        <div className="columns-stack" style={{ display: 'flex', gap: '25px', alignItems: 'stretch' }}>
          <div className="column-item" style={{ flex: 1.6 }}>
            <SubscriptionSection loggedInUser={loggedInUser} />
          </div>

        </div>
      </div>
    </section>
  );
};

// Main Pricing Component
const Pricing = ({  loggedInUser, setLoggedInUser }) => {
  return (
    <div style={{ backgroundColor: colors.bg, minHeight: '100vh' }}>
      <Header 
        loggedInUser={loggedInUser}
        setLoggedInUser={setLoggedInUser}
        topText=""
        midText="Vicktoria"
        botText="Pricing Options"
      />
      <ViewportTracker />
      
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '25px',
        paddingBottom: '25px'
      }}>
        <HeroSection />
        <TwoColumnSection loggedInUser={loggedInUser} />
      </div>
      
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=Judson:wght@400;700&display=swap" rel="stylesheet" />
    </div>
  );
};

export default Pricing;
